import OneSignal from 'onesignal-cordova-plugin';

export const initOneSignal = async () => {
  const appId = import.meta.env.VITE_ONESIGNAL_APP_ID;

  if (!appId) {
    console.error("❌ OneSignal App ID missing");
    return;
  }

  const OS = OneSignal as any;

  try {
    // Initialize SDK
    OS.initialize(appId);
    console.log("✅ OneSignal initialized");

    // Android 13+ requires runtime permission
    const permission = await OS.Notifications.requestPermission(true);
    console.log("🔔 Notification permission status:", permission);

    // Note: pushSubscription.addObserver is not available in the Cordova plugin v5.
    // Use OS.User.pushSubscription.addEventListener if needed in a future SDK update.

  } catch (error) {
    console.error("❌ OneSignal init error:", error);
  }
};